import { css } from 'styled-components';

export const vertical = createVertical({});

export function createVertical({ spacers }: { spacers?: { top?: { color: string; margin: string } } }) {
  return css`
    &::-webkit-scrollbar {
      display: none;
    }

    &::-webkit-scrollbar:vertical {
      display: inline;
      width: 1rem;

      ${spacers?.top?.color ? `background-color: ${spacers?.top?.color};` : ''}
    }

    &::-webkit-scrollbar-thumb:vertical {
      background-color: ${({ theme }) => theme.colors.grey300};
      border-radius: ${({ theme }) => theme.borderRadius.xlarge};
      border: 0.3rem solid ${({ theme }) => theme.colors.white};
    }

    &::-webkit-scrollbar-track:vertical {
      background-color: ${({ theme }) => theme.colors.white};

      ${spacers?.top?.margin ? `margin-top: ${spacers?.top?.margin};` : ''}
    }
  `;
}
